import React from 'react';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import { ErrorGate } from 'components/ErrorGate';
import LoadingGate from 'components/LoadingGate';
// @ts-ignore
import Online from 'components/Online';
// @ts-ignore
import PageTitleAndFilters from 'components/PageTitleAndFilters';
import PageTitleAndFiltersPusher from 'components/PageTitleAndFiltersPusher';
// @ts-ignore
import PageWrapper from 'components/PageWrapper';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Loader } from 'semantic-ui-react';
import { selectSpraySchemaInnerEntityTypeId } from 'services/schemas/selectors';
import { SPRAY_SUBMISSION_LOAD_NAMESPACE } from 'services/spraySubmission/constants';
import { AppState } from 'services/types';
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import { setSprayEventType as setSprayEventTypeAction } from 'services/sprayEventType/actions';
import { SPRAY_EVENT_TYPE_CROP } from 'services/sprayEventType/constants';
import SpraySubmissionConfirmationModal from './components/SpraySubmissionConfirmationModal';
import SpraySubmissionViewPayloadModal from './components/SpraySubmissionViewPayloadModal';
import SpraySubmissionProductsVirtualizedTable from './components/SpraySubmissionProductsVirtualizedTable';
import SpraySubmissionRequest from './components/SpraySubmissionRequest';
import SpraySubmissionSubmitButton from './components/SpraySubmissionSubmitButton';

// Environment
const { REACT_APP_PROJECT_NAME } = process.env;

interface OwnProps {
    match: {
        params: {
            spraySubmissionId: string;
        };
    };
}

interface ConnectedProps {
    spraySchemaInnerEntityTypeId: ReturnType<
        typeof selectSpraySchemaInnerEntityTypeId
    >;
}

interface DispatchProps {
    setSprayEventType: typeof setSprayEventTypeAction;
}

type Props = OwnProps & ConnectedProps & DispatchProps;

export class SubmissionComponent extends React.PureComponent<Props> {
    componentDidMount(): void {
        const { setSprayEventType } = this.props;
        setSprayEventType(SPRAY_EVENT_TYPE_CROP);
    }

    render(): React.ReactElement {
        // eslint-disable-next-line react/destructuring-assignment
        const { spraySubmissionId } = this.props.match.params;
        const { spraySchemaInnerEntityTypeId } = this.props;

        return (
            <ErrorBoundary
                namespace="SpraySubmission"
                FallbackComponent={<ErrorBoundaryAlert />}
            >
                <Helmet>
                    <title>Submission details - {REACT_APP_PROJECT_NAME}</title>
                </Helmet>
                <Online>
                    <SpraySubmissionRequest
                        spraySubmissionId={Number(spraySubmissionId)}
                    />
                </Online>
                <PageTitleAndFilters
                    title="Submission details"
                    backTo="/organization/spray/submissions"
                    hideFilters
                    FirstActionButton={<SpraySubmissionSubmitButton />}
                />
                <PageWrapper top={0} bottom={50}>
                    <LoadingGate
                        namespace={SPRAY_SUBMISSION_LOAD_NAMESPACE}
                        LoadingComponent={
                            <PageWrapper>
                                <Loader active inline="centered" />
                            </PageWrapper>
                        }
                    >
                        <ErrorGate namespace={SPRAY_SUBMISSION_LOAD_NAMESPACE}>
                            <PageTitleAndFiltersPusher>
                                <SpraySubmissionProductsVirtualizedTable
                                    tableId="spraySubmissionProducts"
                                    entityTypeId={spraySchemaInnerEntityTypeId}
                                />
                                <SpraySubmissionConfirmationModal
                                    spraySubmissionId={Number(
                                        spraySubmissionId
                                    )}
                                />
                                <SpraySubmissionViewPayloadModal />
                            </PageTitleAndFiltersPusher>
                        </ErrorGate>
                    </LoadingGate>
                </PageWrapper>
            </ErrorBoundary>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    spraySchemaInnerEntityTypeId: selectSpraySchemaInnerEntityTypeId
});

export default connect(mapStateToProps, {
    setSprayEventType: setSprayEventTypeAction
})(SubmissionComponent);
